<template>
    <div class="modal fade" id="formEntityDetailsModal" role="dialog" aria-labelledby="formEntityLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 id="formEntityLabel">{{model.formName}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <DetailsCard v-model="model"
                                 v-if="showDetails"
                                 @cancel="onCancel">
                    </DetailsCard>
                </div>

                <div class="modal-footer text-muted">
                    <div v-if="model.eventName">
                        <span class="m-1">
                            {{ $t('registers.forms.gridHeaders.eventName') }}
                            <strong>{{ model.eventName }}</strong>
                        </span>
                    </div>
                    <div>
                        <span class="m-1">
                            <span v-if="model.creatorFullName">{{ '' + $t('lastUpdatedBy') }} <strong>{{ model.creatorFullName }}</strong></span>
                            <span v-if="model.updatedAtUtc">{{ ' - ' + $moment(model.updatedAtUtc).format('DD.MM.YYYY HH:mm:ss') }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DynamicFormDetails } from '../../../models/models';
    import DetailsCard from './DetailsCard';

    export default {
        components: {
            DetailsCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDetails: false,
                model: new DynamicFormDetails(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new DynamicFormDetails();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new DynamicFormDetails(this.value);
                    this.showDetails = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal-footer {
        justify-content: flex-start;
    }
</style>
